import { useQuery } from '@tanstack/react-query';
import { apideckApi } from '@/api/apideck.api';

export const crmKeys = {
  all: () => ['crm'] as const,
  connections: () => [...crmKeys.all(), 'connections'] as const,
};

export const useGetCrmConnections = () =>
  useQuery({
    queryKey: crmKeys.connections(),
    queryFn: apideckApi.listConnections,
    refetchOnWindowFocus: true,
  });
